module.exports = __webpack_public_path__ + "img/92085.c5cda45c.svg";